export default "__VITE_ASSET__CDBPvTQH__"